import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_PERIOD } from "@constants";

const initialState = {
  period: DEFAULT_PERIOD,
  city: "todas",
  beneficiaryType: "todos",
  dateRange: { start: null, end: null },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setPeriod(state, action) { state.period = action.payload; },
    setCity(state, action) { state.city = action.payload; },
    setBeneficiaryType(state, action) { state.beneficiaryType = action.payload; },
    setDateRange(state, action) { state.dateRange = action.payload; },
    resetFilters() { return initialState; },
  },
});

export const { setPeriod, setCity, setBeneficiaryType, setDateRange, resetFilters } = filtersSlice.actions;
export const selectFilters = (state) => state.filters;
export const selectPeriod = (state) => state.filters.period;
export const selectCity = (state) => state.filters.city;
export const selectBeneficiaryType = (state) => state.filters.beneficiaryType;
export default filtersSlice.reducer;
